import React, { Component, PropTypes } from 'react'

import EditableField from './editable-field'
import { generateUUID } from 'utils/uuid'

class EditableFieldContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      id: generateUUID(),
    }
  }

  render() {
    return <EditableField {...this.props} id={this.state.id} />
  }

}

EditableField.propTypes = {
  editable: PropTypes.bool,
  icon: PropTypes.any,
  label: PropTypes.string,
  onChange: PropTypes.func,
  prefix: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  important: PropTypes.bool,
}

export default EditableFieldContainer




/** WEBPACK FOOTER **
 ** ./src/components/editable-field/editable-field-container.js
 **/